<template>
  <v-container fluid>
    <v-col cols="9" sm="6" md="4" class="ml-auto mr-auto">
      <v-card class="elevation-2 px-5 rounded-lg py-7 mt-10">
        <v-form ref="form" v-if="!success && !badHash" lazy-validation>
          <div class="text-h5 font-weight-bold text-center indigo--text mb-5">Password Recovery</div>
          <v-text-field
              v-model="password"
              label="Password"
              required
              outlined
              dense
              :rules="passwordRules"
              :append-icon="!show ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="show = !show"
              :type="show ? 'password' : 'text'"
          ></v-text-field>
          <v-btn class="mr-4 white--text" @click="submit" color="indigo" block :disabled="disabled">
            Reset Password
          </v-btn>
        </v-form>
        <div v-if="success">
          <p style="text-align: center">
            You can use new password for login</p>
          <v-btn class="mr-4 white--text" color="indigo" block to="/login">
            Back to Login
          </v-btn>
        </div>
        <div v-if="badHash">
          <p style="text-align: center">
            Your password reset link has expired</p>
          <v-btn class="mr-4 white--text" color="indigo" block to="/forgot-password">
            Get New Reset Password Link
          </v-btn>
        </div>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      password: "",
      disabled: false,
      success: false,
      badHash: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length > 8) || 'Password must be more than 8 characters',
      ],
    };
  },
  created() {
    axios.post("/check-restore-hash", {
        hash: this.$route.params.hash
    }).catch(() => {
        this.badHash = true
    })
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.disabled = true
      this.success = false

      axios.post("/restore-password", {
        password: this.password,
        hash: this.$route.params.hash
      }).then(() => {
        this.success = true
        this.disabled = false
      })
    },
  },
};
</script>

<style scoped>

</style>